module.exports = __webpack_public_path__ + "static/media/website-logo.90050bba.svg";